import { syllable } from 'syllable';
import { fleschKincaid } from 'flesch-kincaid';
export var checkIsBtmInfoValid = function (val) {
    return val.includes('b') && !val.includes('.b0.');
};
export var sanitizePath = function (pathname) {
    // Replace any numeric or dynamic segment in the path with ":id"
    var sanitized = pathname.replace(/\/\d+/g, '/:id');
    if (sanitized.endsWith('/') && sanitized.length > 1) {
        return sanitized.slice(0, -1);
    }
    return sanitized;
};
export var getFleshKincaidGrade = function (text) {
    var _a, _b;
    try {
        if (!text.length)
            return undefined;
        // Check number words ending with '.', '?', '!'
        var numberOfSentences = (_b = (_a = text.match(/[\w|)|}][.?!](\s|$)/g)) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 1;
        var numberOfSyllables = syllable(text);
        var numberOfWords = text.split(' ').filter(function (n) { return n != ''; }).length;
        if (numberOfWords < 5)
            return undefined;
        return {
            reading_ease_grade: fleschKincaid({
                sentence: numberOfSentences,
                word: numberOfWords,
                syllable: numberOfSyllables,
            }),
            reading_ease_sentences: numberOfSentences,
            reading_ease_words: numberOfWords,
            reading_ease_syllables: numberOfSyllables,
        };
    }
    catch (_) {
        return undefined;
    }
};
export var checkIsStarlingKey = function (key) {
    if (key == null)
        return false;
    if (key.length === 1)
        return false;
    if (!/^[A-Za-z0-9_.-]+$/.test(key))
        return false;
    return ['.', '_', '-'].some(function (val) { return key.includes(val); }); // is not one word
};
